<!-- 接龙参与列表 -->
<template>
  <Layout>
    <!-- <div>
      <pre>{{ availableTagsFilter }}</pre>
    </div> -->

    <div
      class="back-view"
      v-show="tableData.length > 0"
      :class="{ 'fullscreen-enable': isFullScreen }"
    >
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="padding-top: 20px; padding-left: 20px; font-weight: 600"
      >
        <el-breadcrumb-item>我的接龙</el-breadcrumb-item>
        <el-breadcrumb-item>{{ activityName }}</el-breadcrumb-item>
        <el-breadcrumb-item style="font-weight: 600"
          >参与列表
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="total-pos">共 {{ tablePage.total }} 条报名数据</div>
      <div class="top-view">
        <div class="top-view-left">
          <el-select
            size="small"
            @change="sortTypeChange()"
            v-model="sortType"
            placeholder="排序"
            clearable
            style="margin: 0 10px 0 0"
          >
            <el-option
              v-for="item in pxoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span
            v-for="(group, groupIdx) in availableTags"
            :key="groupIdx"
            style="
              display: inline-flex;
              align-items: center;
              margin-right: 24px;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              padding: 0 8px;
              height: 32px;
            "
          >
            <!-- 圆点 -->
            <span
              v-if="group[0]"
              :style="{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: group[0].tagColor,
                marginRight: '8px',
              }"
            ></span>
            <!-- 标签名 -->
            <span v-if="group[0]" style="font-size: 13px; margin-right: 8px">{{
              group[0].tagGroup
            }}</span>
            <!-- 编辑按钮 -->
            <i
              class="el-icon-edit"
              style="color: #1976d2; cursor: pointer"
              @click="openTagDialog(groupIdx)"
            ></i>
          </span>
          <div @click="addTagGroup" class="add_tags">+ 设置标签</div>
        </div>
        <div class="top-view-right">
          <!-- {{ isFullScreen ? "退出全屏" : "全屏" }} -->
          <span v-if="!isFullScreen">全屏</span>
          <span v-else style="color: #f00">退出全屏</span>
          <!-- <el-tooltip
              class="item"
              :content="isFullScreen ? '退出全屏' : '全屏'"
              placement="top">
              <div class="icon-btn-item" @click="toggleFullScreen">
                <i :class="isFullScreen ? 'el-icon-full-screen' : 'el-icon-full-screen'"></i>
              </div>
        </el-tooltip> -->
          <div class="icon-btn-item" @click="toggleFullScreen">
            <i
              :class="
                isFullScreen ? 'el-icon-full-screen' : 'el-icon-full-screen'
              "
            ></i>
          </div>
        </div>
        <!-- <el-button size="medium"  @click="addTagGroup"></el-button> -->
      </div>
      <div class="list-back-view">
        <el-table
          :data="tableData"
          :header-cell-style="headerCellStyle"
          border
          style="
            width: 100%;
            font-size: 13px;
            color: rgba(0, 0, 0, 0.88);
            font-family: 'Helvetica Neue', Helvetica, 'PingFang SC',
              'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
              sans-serif;
          "
          size="mini"
          :key="tableKey"
        >
          <el-table-column
            prop="sign_index"
            label="序号"
            width="60"
            align="center"
            fixed="left"
          />
          <el-table-column
            prop="nickname"
            label="用户昵称"
            min-width="100"
            fixed="left"
          />

          <!-- 多组标签分别展示，每组一列 -->
          <el-table-column
            v-for="(group, groupIdx) in availableTags"
            :key="'tag-col-' + groupIdx + '-' + group[0].tagGroup"
            width="150"
          >
            <template slot="header" slot-scope="{}">
              <div style="display: flex; position: relative">
                <div style="display: flex; align-items: center">
                  <span> {{ group[0].tagGroup }} </span>

                  <el-popover placement="bottom" :ref="`popover_${groupIdx}`">
                    <div class="tag-select-box">
                      <div class="check-wrapper">
                        <el-checkbox
                          v-model="availableTagsFilter[groupIdx].checkAll"
                          :indeterminate="
                            availableTagsFilter[groupIdx].isIndeterminate
                          "
                          @change="
                            (val) => {
                              availableTagsFilter[groupIdx].filter = val
                                ? [...group.map((i) => i.tagName), UUID]
                                : [];
                              availableTagsFilter[
                                groupIdx
                              ].isIndeterminate = false;
                            }
                          "
                          >全选({{ totalCount }})
                        </el-checkbox>
                        <el-checkbox-group
                          v-model="availableTagsFilter[groupIdx].filter"
                          @change="
                            (val) => {
                              availableTagsFilter[groupIdx].checkAll =
                                val.length === group.length + 1;
                              availableTagsFilter[groupIdx].isIndeterminate =
                                val.length > 0 && val.length < group.length + 1;
                            }
                          "
                        >
                          <div v-for="tag in group" :key="tag.id">
                            <el-checkbox :key="tag.id" :label="tag.tagName"
                              >{{ tag.tagName }}({{ tag.count }})</el-checkbox
                            >
                          </div>
                          <div>
                            <el-checkbox :label="UUID"
                              >未设置标签({{
                                totalCount -
                                group
                                  .map((i) => i.count || 0)
                                  .reduce((prev, current) => prev + current, 0)
                              }})</el-checkbox
                            >
                          </div>
                        </el-checkbox-group>
                      </div>
                      <div
                        class="check-btn"
                        style="
                          border-top: 1px solid #dcdfe6;
                          padding: 10px 0 0 0;
                        "
                      >
                        <el-button size="mini" @click="cancelPopoverHandler"
                          >取消</el-button
                        >
                        <!-- <el-button size="mini" @click="availableTagsFilter[groupIdx].visible = false;$refs[`popover_${groupIdx}`].showPopper = false" >取消</el-button> -->
                        <el-button
                          type="primary"
                          size="mini"
                          @click="cancelPopoverHandler(true)"
                          >确定</el-button
                        >
                      </div>
                      <!-- <el-option v-for="tag in group" :key="tag.id" :label="tag.tagName" :value="tag.id"></el-option> -->

                      <!-- <el-select v-model="availableTagsFilter[groupIdx].filter" placeholder="请选择标签">
                      <el-option  label="1111" :value="111"></el-option>
                      <el-option  label="2222" :value="222"></el-option>
                      <el-option  label="3333" :value="333"></el-option>
                      <el-option  label="4444" :value="444"></el-option>
                    </el-select> -->
                    </div>
                    <div
                      slot="reference"
                      style="
                        width: 19px;
                        height: 19px;
                        margin-left: 5px;
                        cursor: pointer;
                        cursor: pointer;
                      "
                    >
                      <img
                        src="@/assets/images/filter.svg"
                        style="display: block; width: 100%; height: 100%"
                        alt=""
                      />
                    </div>
                  </el-popover>
                </div>
                <i
                  class="el-icon-delete"
                  style="
                    color: #f56c6c;
                    margin-left: 4px;
                    cursor: pointer;
                    position: absolute;
                    right: 0px;
                    top: 4px;
                  "
                  @click.stop="resetGroupTags(groupIdx)"
                ></i>
              </div>
            </template>
            <template slot-scope="scope">
              <el-dropdown
                style="width: 100%; cursor: pointer"
                @command="
                  (tag) => selectGroupTag(scope.row, group[0].tagGroup, tag)
                "
              >
                <div class="tag-cell" style="width: 100%">
                  <el-tag
                    v-if="scope.row.tags[group[0].tagGroup]"
                    :color="
                      scope.row.tags[group[0].tagGroup].tagColor ||
                      scope.row.tags[group[0].tagGroup].tag_color
                    "
                    size="medium"
                    effect="plain"
                    style="margin-right: 2px; cursor: pointer"
                    >{{
                      scope.row.tags[group[0].tagGroup].tagName ||
                      scope.row.tags[group[0].tagGroup].tag_name
                    }}</el-tag
                  >
                  <svg
                    class="custom-arrow"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    style="margin-left: 4px; vertical-align: middle"
                  >
                    <polygon points="8,12 3,6 13,6" fill="#fff" />
                  </svg>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="tag in getUniqueTags(group)"
                    :key="tag && (tag.id || tag.tagName || tag.tag_name)"
                    :command="tag"
                  >
                    <el-tag
                      :color="tag.tagColor || tag.tag_color"
                      size="medium"
                      effect="plain"
                    >
                      {{ tag.tagName || tag.tag_name }}
                    </el-tag>
                    <span
                      v-if="
                        (scope.row.tags[group[0].tagGroup] &&
                          scope.row.tags[group[0].tagGroup]?.tagName ===
                            tag.tagName) ||
                        scope.row.tags[group[0].tagGroup]?.tag_name ===
                          tag.tagName
                      "
                      style="color: #409eff; margin-left: 4px"
                      >✔</span
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否允许他人查看" align="center">
            <template slot-scope="scope">
              <div style="display: flex; margin-left: 38px">
                <el-switch v-model="scope.row.canLook" active-color="#13ce66" inactive-color="#ff4949"
                  @change="switchChange(scope.row)" />
                <div style="margin-left: 5px">
                  {{ scope.row.canLook == true ? "允许" : "不允许" }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            v-for="(item, tindex) in titleArray"
            :key="tindex"
            :label="item.title"
            :width="itemWidth(item.type)"
            :show-overflow-tooltip="![5, 6, 7, 13, 29, 32].includes(item.type)"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 5
                "
              >
                <div v-if="scope.row.sign_info[tindex].value == ''">
                  暂无图片
                </div>
                <div v-else>
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="scope.row.sign_info[tindex].value[0]"
                    fit="cover"
                    :preview="true"
                    :preview-src-list="scope.row.sign_info[tindex].value"
                  />
                  <span style="margin-left: 10px"
                    >共{{ scope.row.sign_info[tindex].value.length }}张</span
                  >
                </div>
              </template>
              <template
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 36
                "
              >
                <div v-if="!scope.row.sign_info[tindex].localValue">
                  暂无图片
                </div>
                <div v-else>
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="scope.row.sign_info[tindex].localValue.split(',')[0]"
                    fit="cover"
                    :preview="true"
                    :preview-src-list="
                      scope.row.sign_info[tindex].localValue.split(',')
                    "
                  />
                  <span style="margin-left: 10px"
                    >共{{
                      scope.row.sign_info[tindex].localValue.split(",").length
                    }}张</span
                  >
                </div>
              </template>
              <template
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 6
                "
              >
                <!-- <el-popover
                  placement="top-start"
                  trigger="hover"
                  popper-class="video-popover"
                  >
                  <video
                    :id="'myVideo' + scope.$index"
                    src="https://jielongvideo.youzhiapp.com/10ce9eb5898371f0aac25017e1f90102/9ef9b775d6ab41e187cb9d51c76749f0-09b1a623f7e0d7802ea5f850017c5d49-sd.mp4?auth_key=1756985975-d67aff9283574a32938ddd44af9f2b2b-0-cadc1f0b8fd58bdc5d783f4f8590bc9e"
                    enable-danmu="true"
                    mode="widthFix"
                    :show-fullscreen-btn="false"
                    style="width: 100px; height:100px"
                    controls
                />
                  <el-button type="text" slot="reference">查看视频</el-button>
                </el-popover> -->

                <div
                  v-if="scope.row.sign_info[tindex].value"
                  @click="
                    lookDetailVideo(scope.$index, scope.row.sign_info[tindex])
                  "
                  class="video-wrapper"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    width: 60px;
                    height: 60px;
                  "
                >
                  <el-image
                    style="width: 60px; height: 60px; cursor: pointer"
                    :src="
                      'https://ossfastmake.mustke.com/' +
                      scope.row.sign_info[tindex].coverURL
                    "
                    fit="cover"
                  />
                  <i
                    class="el-icon-video-play"
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      font-size: 24px;
                      color: #fff;
                      cursor: pointer;
                    "
                  ></i>
                </div>

                <!-- <el-button v-if="scope.row.sign_info[tindex].vid" type="text" @click="lookDetailVideo(scope.row.sign_info[tindex])">查看视频</el-button> -->
                <span v-else>无</span>

                <!-- <video
                    :id="'myVideo' + scope.$index"
                    :src="scope.row.sign_info[tindex].value"
                    enable-danmu="true"
                    mode="widthFix"
                    :show-fullscreen-btn="false"
                    style="width: 80px; height:80px"
                    controls
                /> -->
              </template>
              <div
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 7
                "
              >
                <audio
                  v-if="scope.row.sign_info[tindex].value"
                  controls
                  ref="audio"
                  id="tableAudio"
                >
                  <source :src="scope.row.sign_info[tindex].value" />
                </audio>
                <span v-else>无</span>
              </div>
              <div
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 12
                "
              >
                {{ scope.row.sign_info[tindex].value || "无" }}
              </div>
              <div
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 29
                "
              >
                <div v-if="scope.row.sign_info[tindex].value == ''">
                  暂无图片
                </div>
                <img
                  v-else
                  style="width: 60px; height: 60px"
                  :src="imageUrl + scope.row.sign_info[tindex].value"
                />
              </div>
              <div
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type == 32
                "
              >
                <div
                  v-if="
                    !scope.row.sign_info[tindex].value ||
                    JSON.parse(scope.row.sign_info[tindex].value).length === 0
                  "
                >
                  无
                </div>
                <div
                  v-else
                  v-for="(fileItem, fileIndex) in JSON.parse(
                    scope.row.sign_info[tindex].value
                  )"
                  :key="fileIndex"
                  class="no-wrap"
                >
                  <a
                    :href="imageUrl2 + fileItem.fileUrl"
                    target="_blank"
                    download
                    >{{ fileItem.name }}</a
                  >
                </div>
              </div>
              <div
                v-if="
                  scope.row.sign_info[tindex] &&
                  scope.row.sign_info[tindex].type != 5 &&
                  scope.row.sign_info[tindex].type != 6 &&
                  scope.row.sign_info[tindex].type != 12 &&
                  scope.row.sign_info[tindex].type != 29 &&
                  scope.row.sign_info[tindex].type != 7 &&
                  scope.row.sign_info[tindex].type != 32 &&
                  scope.row.sign_info[tindex].type != 36
                "
              >
                {{ scope.row.sign_info[tindex].value || "无" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.canLook ? '列表展示' : '取消列表展示'"
                placement="top"
              >
                <el-button
                  :icon="
                    scope.row.canLook ? 'el-icon-document' : 'el-icon-close'
                  "
                  style="color: #019688; font-size: 14px"
                  type="text"
                  size="small"
                  @click="toggleAllowView(scope.row)"
                >
                </el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <el-tooltip
                class="item"
                effect="dark"
                content="查看"
                placement="top"
              >
                <el-button
                  icon="el-icon-view"
                  style="color: #019688; font-size: 14px"
                  type="text"
                  size="small"
                  @click="lookClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
              >
                <el-button
                  icon="el-icon-edit"
                  style="color: #019688; font-size: 14px"
                  type="text"
                  size="small"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
              >
                <el-button
                  icon="el-icon-delete"
                  style="color: #019688; font-size: 14px"
                  type="text"
                  size="small"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <template
                v-if="scope.row.addcomment == '' || !scope.row.addcomment"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="点评"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-chat-line-round"
                    style="color: #019688; font-size: 14px"
                    type="text"
                    size="small"
                    @click="talkClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已点评"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-chat-line-round"
                    style="color: #019688; font-size: 14px"
                    type="text"
                    size="small"
                    @click="talkClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="text-align: center; margin-top: 20px"
          v-show="tablePage.total"
        >
          <el-pagination
            background
            layout="sizes,prev, pager, next,total"
            :page-sizes="[20, 50, 100, 200]"
            :total="tablePage.total"
            :current-page="tablePage.pageNum"
            :page-size="tablePage.pageSize"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-show="tableData.length === 0" style="text-align: center">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="padding-top: 20px; padding-left: 20px"
      >
        <el-breadcrumb-item>我的接龙</el-breadcrumb-item>
        <el-breadcrumb-item>{{ activityName }}</el-breadcrumb-item>
        <el-breadcrumb-item>报名列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="height: 180px; margin-top: 150px">
        <el-image
          style="width: 180px; height: 180px"
          :src="require('@/assets/images/nomessage.png')"
        ></el-image>
      </div>

      <span style="margin-top: 80px; font-size: 25px">
        {{ tableLoading ? "加载中..." : "暂无数据" }}
      </span>
    </div>
    <!-- 抽屉弹窗 -->
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :withHeader="false"
      :before-close="handleClose"
      :size="600"
    >
      <div>
        <div style="margin: 10px">
          <div class="drawer-nav-top">
            <div></div>
            <span>查看用户</span>
            <i class="el-icon-close" @click="handleClose"></i>
          </div>
          <el-form
            label-position="right"
            ref="form"
            :model="form"
            class="detail-form"
          >
            <!-- :rules="{
                  required: true,
                  message: '不能为空',
                  trigger: 'blur',
                }" -->
            <el-form-item
              label="参与时间"
              style="margin-bottom: 0; flex-direction: row"
              class="look-time"
            >
              <div>
                <div>{{ add_time }}</div>
              </div>
            </el-form-item>
            <el-form-item
              style="margin-bottom: 0"
              v-for="(infoItem, index) in detailPeople.signInfoArray"
              :key="infoItem.id + index"
              :label="`${index + 1}. ${infoItem.fieldName}`"
              :rules="{
                required: infoItem.isRequired == 1,
                message: '不能为空',
                trigger: 'blur',
              }"
            >
              <!-- infoItem.type  5 图片  6 视频   12 地址-->
              <div
                v-if="infoItem.type == 5"
                style="display: flex; flex-wrap: wrap"
              >
                <div
                  v-for="(pic, picIndex) in infoItem.value"
                  :key="picIndex"
                  class="pic-back"
                >
                  <el-image
                    style="width: 120px; height: 80px"
                    :src="imageUrl + pic"
                    :preview-src-list="[imageUrl + pic]"
                    fit="cover"
                  ></el-image>
                  <div class="pic-del-back">
                    <el-button
                      v-show="canEdit"
                      @click="delPicClick(index, picIndex)"
                      type="text"
                      icon="el-icon-error"
                      style="color: darkgray; font-size: 20px"
                    ></el-button>
                  </div>
                </div>

                <div
                  v-show="infoItem.value.length < 6 && canEdit"
                  class="file-upload-btn"
                >
                  <div class="upload-icon">
                    <i class="el-icon-plus"></i>
                  </div>
                  <span>选择微信文件上传</span>

                  <input
                    class="updateFileBtn"
                    type="file"
                    id="filesInput"
                    multiple
                    @change="(event) => handleImgUpload(event, index)"
                  />
                </div>

                <div v-if="!canEdit && infoItem.value?.length === 0">
                  暂无数据
                </div>
              </div>
              <!-- 视频 -->
              <div v-if="infoItem.type == 6">
                <div
                  v-show="infoItem.value"
                  style="position: relative"
                  class="video-box"
                >
                  <video
                    :id="'video'"
                    :src="infoItem.value"
                    enable-danmu="true"
                    mode="widthFix"
                    :show-fullscreen-btn="false"
                    style="width: 100%; height: 190px"
                    controls
                  ></video>
                  <div class="pic-del-back">
                    <el-button
                      v-show="canEdit"
                      @click="delVideoClick(index)"
                      type="text"
                      icon="el-icon-error"
                      style="color: darkgray; font-size: 20px"
                    ></el-button>
                  </div>
                </div>
                <div v-show="infoItem.value == ''">暂无数据</div>
                <div
                  class="file-upload-btn"
                  v-show="
                    canEdit == true &&
                    (infoItem.value == '' ||
                      infoItem.value == null ||
                      infoItem.value == undefined)
                  "
                >
                  <div class="upload-icon">
                    <i class="el-icon-plus"></i>
                  </div>
                  <span>点击上传视频</span>
                  <input
                    class="updateFileBtn"
                    type="file"
                    id="filesInput"
                    @change="(event) => handleMpFourUpload(event, index)"
                  />
                  <!-- <input class="updateVideoBtn" type="file" id="imageInput5" accept=".mp4"
                    @change="(event) => handleMpFourUpload(event, index)" />
                  <i class="el-icon-circle-plus"></i>&nbsp;点击上传视频 -->
                </div>
              </div>
              <!-- 音频 -->
              <div v-if="infoItem.type == 7">
                <div>{{ infoItem.value.name }}</div>
                <audio controls ref="audio" id="myAudio">
                  <source :src="infoItem.value.url" />
                </audio>
                <div v-if="!canEdit && !infoItem.value.url">暂无数据</div>
                <div
                  class="addSmallBtn b-marT-10"
                  v-show="
                    canEdit == true &&
                    (infoItem.value.url == '' ||
                      infoItem.value.url == null ||
                      infoItem.value.url == undefined)
                  "
                >
                  <input
                    class="updateVideoBtn"
                    type="file"
                    id="imageInput4"
                    accept=".mp3"
                    @change="(event) => handleMpThreeUpload(event, index)"
                  />
                  <i class="el-icon-circle-plus"></i>&nbsp;点击上传音频
                </div>
              </div>
              <!-- 地图 -->
              <div v-if="infoItem.type == 12">
                <div>{{ infoItem.value.name }}</div>
                <div>{{ infoItem.value.address }}</div>
                <div @click="changeAddressClick(index)" class="address-box">
                  <img
                    src="https://ossfastmake.mustke.com//static/newIndex/wznew.png"
                    class="address-icon"
                    alt="地址图标"
                  />
                  <div class="address-content">
                    <div>{{ infoItem.value.address }}</div>
                    <div v-show="infoItem.value == ''">暂无数据</div>
                  </div>
                </div>

                <!-- <el-button v-show="infoItem.value && canEdit" @click="changeAddressClick(index)" type="text" class="del-button">修改</el-button> -->
              </div>
              <!-- 多选 -->
              <div v-if="infoItem.type == 4" class="modern-multi-select">
                <el-select
                  v-model="infoItem.value"
                  multiple
                  placeholder="请选择选项"
                  :disabled="canEdit == false"
                  @change="(event) => checkboxChange(event, index)"
                  class="modern-select-dropdown"
                >
                  <el-option
                    v-for="(dItem, dindex) in infoItem.contentArray"
                    :key="dindex"
                    :label="dItem.value"
                    :value="dItem.value"
                  >
                  </el-option>
                </el-select>
                <template v-if="infoItem.maxValue == infoItem.minValue">
                  <div class="more-select-tips">
                    必选{{ infoItem.maxValue }}项。
                  </div>
                </template>
                <template v-if="infoItem.maxValue != infoItem.minValue">
                  <div class="more-select-tips" v-if="infoItem.maxValue != 0">
                    最多可选{{ infoItem.maxValue }}项，最少可选{{
                      infoItem.minValue
                    }}项。
                  </div>
                  <div class="more-select-tips" v-if="infoItem.maxValue == 0">
                    最少可选{{ infoItem.minValue }}项。
                  </div>
                </template>
              </div>

              <!-- 省市区 -->
              <div v-if="infoItem.type == 8">
                <div
                  v-if="
                    !canEdit &&
                    !infoItem.value &&
                    !infoItem.provinceCityDistrictAddress
                  "
                >
                  暂无数据
                </div>
                <div v-if="canEdit == false">
                  {{ infoItem.value }}{{ infoItem.provinceCityDistrictAddress }}
                </div>
                <div v-else>
                  <div>
                    <div
                      class="location-selector-box el-cascader-box"
                      @click="changeShengshiqu(index)"
                    >
                      <img
                        src="https://ossfastmake.mustke.com//static/newIndex/wznew.png"
                        class="location-icon"
                        alt="定位图标"
                      />
                      <p class="location-text">
                        {{ infoItem.value || "请选择省/市/区" }}
                      </p>
                      <!-- <el-button type="text" style="height: 37px; margin-left: 10px" @click="changeShengshiqu(index)">修改</el-button> -->
                    </div>
                    <!-- infoItem.areaSelectType 0：省 1：省市 2：省市区 3：省市区详细地址  -->
                    <el-cascader
                      :options="options"
                      v-model="selectedOptions"
                      @change="handleChange"
                      clearable
                      v-show="
                        SSQIndex &&
                        (infoItem.areaSelectType == 3 ||
                          infoItem.areaSelectType == 2)
                      "
                    >
                    </el-cascader>
                    <el-cascader
                      :options="SSoptions"
                      v-model="selectedOptions"
                      @change="handleChange"
                      clearable
                      placeholder="请选择省市"
                      class="modern-cascader"
                      v-show="SSQIndex && infoItem.areaSelectType == 1"
                    >
                    </el-cascader>

                    <el-cascader
                      :options="Soptions"
                      v-model="selectedOptions"
                      @change="handleChange"
                      clearable
                      v-show="SSQIndex && infoItem.areaSelectType == 0"
                    >
                    </el-cascader>
                  </div>
                  <el-input
                    v-show="infoItem.areaSelectType == 3"
                    style="margin-top: 10px"
                    v-model="infoItem.provinceCityDistrictAddress"
                    placeholder="详细地址"
                  ></el-input>
                </div>
              </div>
              <!-- 日期/时间 -->
              <div v-if="infoItem.type == 3">
                <template v-if="infoItem.timeSelectType == 0">
                  <el-time-picker
                    v-model="infoItem.value"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="任意时间点"
                  >
                  </el-time-picker>
                </template>
                <template v-if="infoItem.timeSelectType == 1">
                  <el-date-picker
                    v-model="infoItem.value"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    @change="monthValueChange"
                    placeholder="选择月"
                  >
                  </el-date-picker>
                </template>
                <template v-if="infoItem.timeSelectType == 2">
                  <el-date-picker
                    v-model="infoItem.value"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </template>
                <template v-if="infoItem.timeSelectType == 3">
                  <el-date-picker
                    v-model="infoItem.value"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </template>
              </div>
              <!-- 时间区间 -->
              <div v-if="infoItem.type == 31">
                <template v-if="infoItem.dateSelectType == 0">
                  <el-time-picker
                    is-range
                    v-model="infoItem.value"
                    range-separator="~"
                    format="HH:mm"
                    value-format="HH:mm"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    @change="monthValueChange"
                  >
                  </el-time-picker>
                </template>
                <template v-if="infoItem.dateSelectType == 1">
                  <el-date-picker
                    v-model="infoItem.value"
                    type="monthrange"
                    range-separator="~"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </template>
                <template v-if="infoItem.dateSelectType == 2">
                  <el-date-picker
                    v-model="infoItem.value"
                    type="daterange"
                    range-separator="~"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="monthValueChange"
                  >
                  </el-date-picker>
                </template>
                <template v-if="infoItem.dateSelectType == 3">
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="~"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </template>
              </div>
              <!-- 文件 -->
              <div v-if="infoItem.type == 32" class="modern-file-upload">
                <div
                  class="file-list"
                  v-if="infoItem.value && infoItem.value.length > 0"
                >
                  <a
                    :href="imageUrl2 + fileItem.fileUrl"
                    target="_blank"
                    download
                    v-for="(fileItem, fileIndex) in infoItem.value"
                    :key="fileIndex"
                  >
                    <div class="file-item">
                      <div class="file-icon">
                        <!-- Excel文件 -->
                        <div
                          v-if="
                            fileItem.lastName === 'xls' ||
                            fileItem.lastName === 'xlsx'
                          "
                          class="file-type-icon excel-icon"
                        >
                          <i class="el-icon-document"></i>
                        </div>
                        <!-- PDF文件 -->
                        <div
                          v-else-if="fileItem.lastName === 'pdf'"
                          class="file-type-icon pdf-icon"
                        >
                          <span>PDF</span>
                        </div>
                        <!-- Word文件 -->
                        <div
                          v-else-if="
                            fileItem.lastName === 'doc' ||
                            fileItem.lastName === 'docx'
                          "
                          class="file-type-icon word-icon"
                        >
                          <span>W</span>
                        </div>
                        <!-- PPT文件 -->
                        <div
                          v-else-if="
                            fileItem.lastName === 'ppt' ||
                            fileItem.lastName === 'pptx'
                          "
                          class="file-type-icon ppt-icon"
                        >
                          <span>P</span>
                        </div>
                        <!-- 压缩文件 -->
                        <div
                          v-else-if="
                            fileItem.lastName === 'zip' ||
                            fileItem.lastName === 'rar'
                          "
                          class="file-type-icon zip-icon"
                        >
                          <i class="el-icon-folder"></i>
                        </div>
                        <!-- 默认文件 -->
                        <div v-else class="file-type-icon default-icon">
                          <i class="el-icon-document"></i>
                        </div>
                      </div>
                      <div class="file-info">
                        <div class="file-name">{{ fileItem.name }}</div>
                        <div class="file-size">
                          大小: {{ formatFileSize(fileItem.size) }}
                        </div>
                      </div>

                      <div
                        v-show="canEdit"
                        class="file-delete-btn"
                        @click.stop.prevent="delFile(index, fileIndex)"
                      >
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </a>
                </div>
                <div v-else>暂无数据</div>
                <div
                  v-show="infoItem.value.length < 6 && canEdit"
                  class="file-upload-btn"
                >
                  <div class="upload-icon">
                    <i class="el-icon-plus"></i>
                  </div>
                  <span>选择微信文件上传</span>

                  <input
                    class="updateFileBtn"
                    type="file"
                    id="filesInput"
                    multiple
                    @change="
                      (event) => handleFilesUpload(event, index, infoItem)
                    "
                  />
                </div>
                <!-- <div class="pic-add" v-show="infoItem.value.length < 6 && canEdit == true">
                  +
                  <input class="updateFileBtn" type="file" id="filesInput" multiple
                    @change="(event) => handleFilesUpload(event, index, infoItem)" />
                </div> -->
              </div>
              <!-- 签名 -->
              <div v-if="infoItem.type == 29">
                <div v-if="!infoItem.value">暂无数据</div>
                <el-image
                  v-else
                  style="width: 120px; height: 80px"
                  :src="imageUrl + infoItem.value"
                  :preview-src-list="[imageUrl + infoItem.value]"
                  fit="cover"
                ></el-image>
              </div>
              <!-- 身份证 -->
              <div v-if="infoItem.type == 10">
                <div v-if="!canEdit">
                  {{ infoItem.value || "暂无数据" }}
                </div>
                <el-input
                  v-else
                  :disabled="canEdit == false"
                  v-model="infoItem.value"
                  @blur="validateIdCard(infoItem)"
                  placeholder="请输入18位身份证号码"
                >
                </el-input>
              </div>
              <!-- 性别 -->
              <div v-if="infoItem.type == 2" class="radio-box">
                <div v-if="infoItem.displayStyle == 2">
                  <el-select
                    v-model="infoItem.value"
                    placeholder="请选择选项"
                    :disabled="canEdit == false"
                    @change="(event) => singleSelectChange(event, index)"
                    class="modern-select-dropdown"
                  >
                    <el-option
                      v-for="(singleItem, singleIndex) in JSON.parse(
                        infoItem.content
                      )"
                      :key="singleIndex"
                      :label="singleItem.value"
                      :value="singleItem.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-radio-group
                  v-model="infoItem.value"
                  :disabled="canEdit == false"
                  v-else
                >
                  <el-radio
                    v-for="(singleItem, singleIndex) in JSON.parse(
                      infoItem.content
                    )"
                    :key="singleIndex"
                    :label="singleItem.value"
                    >{{ singleItem.value }}
                  </el-radio>
                </el-radio-group>
              </div>
              <div
                v-if="
                  infoItem.type != 2 &&
                  infoItem.type != 4 &&
                  infoItem.type != 5 &&
                  infoItem.type != 6 &&
                  infoItem.type != 7 &&
                  infoItem.type != 8 &&
                  infoItem.type != 10 &&
                  infoItem.type != 31 &&
                  infoItem.type != 32 &&
                  infoItem.type != 29 &&
                  infoItem.type != 3 &&
                  infoItem.type != 12
                "
              >
                <div v-if="canEdit == false" class="read-value">
                  {{ infoItem.value || "暂无数据" }}
                </div>
                <el-input v-else v-model="infoItem.value"></el-input>
              </div>
            </el-form-item>

            <el-divider></el-divider>
            <el-form-item label="评语">
              <!-- <el-input v-if="canTalk == true" type="textarea" v-model="detailPeople.addcomment"></el-input>
              <div v-else>{{ detailPeople.addcomment }}</div> -->
              <el-input
                type="textarea"
                v-model="detailPeople.addcomment"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                v-show="canTalk == true || canEdit == true"
                type="primary"
                @click="onSubmit()"
                >提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>

    <!-- 地图 -->
    <el-dialog
      title="提示"
      width="600px"
      :visible.sync="addressDialog"
      :destroy-on-close="true"
      center
    >
      <iframe
        id="mapPage2"
        width="100%"
        height="100%"
        style="width: 550px; height: 600px"
        frameborder="0"
        src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=LG3BZ-FLACZ-YJPX7-ZKGLD-ZODTK-JGB34&referer=myapp"
      >
      </iframe>
      <span slot="footer">
        <el-button @click="addressDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitMap">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="activityName"
      custom-class="dialogClass"
      :visible.sync="manageDialogVisible"
      width="455px"
      center
    >
      <div
        style="
          text-align: center;
          background-color: #f6f7fa;
          padding-top: 0px;
          padding-bottom: 30px;
        "
      >
        <div>
          <el-image :src="codeUrl" class="code-image"></el-image>
        </div>
        <div>扫码进入活动详情参与接龙</div>
        <el-button
          @click="downLoadCodePic(codeUrl)"
          type="primary"
          round
          style="margin-top: 40px"
          >下载接龙二维码
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="
        editingGroupIdx === availableTags.length ? '新建标签' : '修改标签'
      "
      :visible.sync="tagDialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <div class="tag-edit-list">
        <el-input
          v-model="groupName"
          placeholder="请输入分组名称"
          style="margin-bottom: 12px"
        ></el-input>
        <div
          class="tag-edit-row"
          v-for="(tag, idx) in visibleEditTags"
          :key="tag.id"
        >
          <el-input
            v-model="tag.tagName"
            placeholder="请输入标签名称"
            class="tag-edit-input"
            maxlength="8"
          />
          <span
            class="tag-edit-color-btn"
            :style="{
              background: tag.tagColor,
              color: '#fff',
              marginLeft: '10px',
              borderRadius: '6px',
              padding: '0 16px',
              height: '36px',
              display: 'inline-flex',
              alignItems: 'center',
              cursor: 'pointer',
              fontWeight: 500,
            }"
            @click="showColorPicker(idx, $event)"
            >编辑颜色</span
          >
          <span class="tag-edit-delete" @click="removeTag(idx)">删除</span>
          <!-- 自定义颜色选择器弹窗 -->
          <div
            v-if="colorPickerVisible && colorPickerIndex === idx"
            class="color-picker-pop"
            :style="colorPickerStyle"
          >
            <div class="color-grid">
              <div
                v-for="color in colorPalette"
                :key="color"
                :style="{ background: color }"
                class="color-cell"
                :class="{ active: color === selectedColor }"
                @click="selectColor(color)"
              >
                <i v-if="color === selectedColor" class="el-icon-check"></i>
              </div>
            </div>
            <!-- <div class="color-more" >
              <i class="el-icon-brush"></i>
              <el-color-picker v-model="customColor" @change="colorChange"></el-color-picker>
            </div> -->
            <div class="color-picker-footer">
              <el-button type="primary" size="mini" @click="confirmColor"
                >确定
              </el-button>
            </div>
          </div>
        </div>
        <div class="tag-edit-add" @click="addTag">+ 新增选项</div>
      </div>
      <div slot="footer" class="dialog-footer" style="padding-top: 0">
        <el-button
          type="primary"
          class="tag-edit-confirm"
          @click="confirmTagEdit"
          >确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="videoTitle"
      :visible.sync="videoVisible"
      width="600px"
      @close="closeVideoHandler"
    >
      <video
        id="my-dialog-video"
        :src="dialogVideoUrl"
        enable-danmu="true"
        mode="widthFix"
        :show-fullscreen-btn="false"
        style="width: 100%; max-height: 700px"
        controls
      />
    </el-dialog>

    <el-dialog
      title="音频预览"
      :visible.sync="audioVisible"
      width="600px"
      @close="closeAudioHandler"
    >
      <audio controls id="my-dialog-audio" style="display: block; width: 100%">
        <source :src="dialogAudioUrl" />
      </audio>
    </el-dialog>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

var uploader;
const VODUpload = window.AliyunUpload.Vod;

// import router from "../../../router/index";
/**
 * Basic-table component
 */
import {
  getSignList,
  sleDetails,
  updateSignInfo,
  getProjectManageAdmin,
  updatecommentlanguage,
  updateSignInfoLook,
  signDel,
  getActivityCode,
  updateTag,
  listTags,
  listTagsCount,
  setOrderTag,
  delTagByGroup,
  getNewVideoPathUrl,
  getVideoPathToken,
} from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import serverConfig from "@/utils/config/index.js";
import {
  codeToText,
  regionData,
  provinceAndCityData,
} from "element-china-area-data";
import axios from "axios";

export default {
  page() {
    const title = this.activityName + " - 报名列表" || "报名列表";
    return {
      title: title,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: { Layout },
  data() {
    const availableTags = [];
    return {
      tableLoading: true,
      UUID: "550e8400-e29b-41d4-a716-446655440000",
      tableKey: 1,
      totalCount: 0,
      // 分组临时名称
      groupName: "",
      isFullScreen: false,
      audioVisible: false,
      dialogAudioUrl: "",
      videoVisible: false,
      dialogVideoUrl: "",
      addressDialog: false,
      imageUrl2: "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/",
      addressIndex: null,
      SSQIndex: null, //省市区
      videoUrlCache: new Map(),
      options: regionData,
      SSoptions: provinceAndCityData,
      Soptions: provinceAndCityData, //省
      selectedOptions: [],

      address: "",
      poiname: "", //地址名称
      longitude: "", //纬度
      latitude: "", //经度

      imageUrl: imageUrl,
      activityId: "",
      drawer: false,
      direction: "rtl",
      form: {},

      pxoptions: [
        {
          label: "倒序",
          value: "1",
        },
        {
          label: "正序",
          value: "2",
        },
        {
          label: "姓名排序",
          value: "3",
        },
      ],
      sortType: "1",
      tableData: [],
      availableTags,
      availableTagsFilter: [],
      selectedTags: [],
      // tableData: [
      //   {
      //     id: 1,
      //     nickname: '张三',
      //     tags: [{ id: 1, tagName: 'VIP', color: '#f56c6c' }]
      //   },
      //   {
      //     id: 2,
      //     nickname: '李四',
      //     tags: []
      //   }
      // ],

      titleArray: [],

      tablePage: {
        pageNum: 1, //
        pageSize: 20,
        total: 0,
      },
      editItem: null, //查看，编辑项目

      detailPeople: {
        signInfoArray: [],
        addcomment: "",
      }, //用户详情

      isOtherPeople: "", // 1=创建者、2=管理员、3=普通用户

      canEdit: false, //判断是否可以编辑
      canTalk: false, //判断是否可以评论

      userID: localStorage.getItem("userID"),
      selectedFile: null,
      activityName: "",
      codeUrl: "",
      manageDialogVisible: false,
      commonInfo: {},

      // 基本案列数据
      radiolist1: [
        {
          name: "苹果",
          disabled: false,
        },
        {
          name: "香蕉",
          disabled: false,
        },
        {
          name: "橙子",
          disabled: false,
        },
        {
          name: "榴莲",
          disabled: false,
        },
      ],
      // u-radio-group的v-model绑定的值如果设置为某个radio的name，就会被默认选中
      radiovalue1: "苹果",
      tagDialogVisible: false,
      editTags: [
        { id: 1, tagName: "", tagColor: "#f6c026" },
        { id: 2, tagName: "", tagColor: "#409eff" },
        { id: 3, tagName: "", tagColor: "#67c23a" },
        { id: 4, tagName: "", tagColor: "#f56c6c" },
      ],
      colorList: [
        "#f6c026",
        "#409eff",
        "#67c23a",
        "#f56c6c",
        "#e6a23c",
        "#909399",
      ],
      colorDialogVisible: false,
      colorPalette: [
        "#ffffff",
        "#f5222d",
        "#fa541c",
        "#fa8c16",
        "#fadb14",
        "#52c41a",
        "#13c2c2",
        "#1890ff",
        "#2f54eb",
        "#722ed1",
        "#eb2f96",
        "#bfbfbf",
        "#8c8c8c",
        "#262626",
        "#f6c026",
        "#409eff",
        "#67c23a",
        "#f56c6c",
        "#e6a23c",
        "#909399",
        "#ffb6b9",
        "#ffde7d",
        "#b5ead7",
        "#c7ceea",
        "#ffdac1",
        "#ff9aa2",
        "#ffb347",
        "#baffc9",
        "#bae1ff",
        "#d5a6bd",
        "#c2b280",
        "#b0e0e6",
        "#f4cccc",
        "#ea9999",
        "#ffe599",
        "#b6d7a8",
        "#a2c4c9",
        "#d9ead3",
        "#fce5cd",
        "#d0e0e3",
        "#f9cb9c",
        "#b7b7b7",
        "#6fa8dc",
        "#e06666",
        "#ffd966",
      ],
      selectedColor: "",
      customColor: "#f6c026",
      editingTagIdx: null,
      colorPickerVisible: false,
      colorPickerIndex: null,
      colorPickerStyle: {},
      add_time: "",
      editingGroupIdx: null,
      activityKey: "",
      videoTitle: "视频预览",
    };
  },
  mounted() {
    this.subAddress();
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  created() {
    if (this.$route.query.activityId) {
      this.activityId = this.$route.query.activityId;
      this.activityName = this.$route.query.activityName;
      this.setPageTitle();
      this.getMessage();
      this.getProjectManageAdmin();

      for (const key in this.Soptions) {
        let item = this.Soptions[key];
        this.$delete(item, "children");
      }
      if (this.availableTags && Array.isArray(this.availableTags)) {
        this.selectedTags = this.availableTags.map(
          (group) => group[0]?.id || null
        );
      }
    }
    if (this.$route.query.alias) {
      this.activityKey = this.$route.query.alias;
      this.activityName = this.$route.query.activityName;
      this.setPageTitle();
      this.getMessage();

      for (const key in this.Soptions) {
        let item = this.Soptions[key];
        this.$delete(item, "children");
      }
      if (this.availableTags && Array.isArray(this.availableTags)) {
        this.selectedTags = this.availableTags.map(
          (group) => group[0]?.id || null
        );
      }
    }
    this.fetchTagList();
  },
  methods: {
    cancelPopoverHandler(flag = false) {
      // 确定按钮
      if (flag) {
        let seelctedTagObj = {};
        this.availableTagsFilter.forEach((group) => {
          seelctedTagObj[group.key] = group.filter;
        });

        this.getMessage({
          tagFilters: seelctedTagObj,
        });
      }
      document.body.click();
    },
    itemWidth(type) {
      // 手机号
      if (type === 11) {
        return 110;
      }
      // 数量
      else if (type === 13) {
        return 110;
      } else if (type === 3) {
        return 110;
      } else if (type === 7) {
        return 320;
      }
      return 220;
    },
    initUploader(cb) {
      var that = this;
      let loading;
      // 初始化uploader
      uploader = new VODUpload({
        timeout: 300000,
        region: "cn-shanghai",
        userId: "2101303984639806000",
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          //console.log("addFileSuccess" + JSON.stringify(uploadInfo))
          console.log(uploadInfo, "addFileSuccess");
          uploader.startUpload();
        },
        // 开始上传
        onUploadstarted: async function (uploadInfo) {
          //console.log('文件开始上传...');
          // uni.showLoading({
          //     title: '视频开始上传...'
          // });
          console.log(uploadInfo, "onUploadstarted");

          loading = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let result = await getVideoPathToken();
          that.akInfo = result.data;
          uploader.setSTSToken(
            uploadInfo,
            that.akInfo.AccessKeyId,
            that.akInfo.AccessKeySecret,
            that.akInfo.SecurityToken
          );
        },
        onUploadSucceed: (uploadInfo) => {
          console.log(
            "onUploadSucceed: " +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );

          console.log(uploadInfo, "onUploadSucceed");
          cb(uploadInfo, loading);
        },
        onUploadFailed: (uploadInfo, code, message) => {
          loading.close();
          console.log(uploadInfo, code, message, "onUploadFailed");
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          // console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
          // console.log('文件已暂停上传!')
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {},
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          console.log(uploadInfo, "onUploadTokenExpired");
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log(uploadInfo, "onUploadEnd");
        },
      });
      return uploader;
    },
    async getVideoUrl(row) {
      // return this.imageUrl2 + row.fileUrl
      const videoUrl = await this._getNewVideoPathUrl(row.vid, row.value);
      return videoUrl;
    },
    async lookDetailVideo(index, row) {
      const videoUrl = await this._getNewVideoPathUrl(row.vid, row.value);
      this.dialogVideoUrl = videoUrl;
      this.videoTitle = `${this.tableData[index].sign_index}-${this.tableData[index].nickname}-视频预览`;
      this.videoVisible = true;
    },
    closeVideoHandler() {
      const video = document.getElementById("my-dialog-video");
      if (video) {
        video.pause();
      }
    },
    lookDetailAudio(row) {
      this.dialogAudioUrl = row.value;
      this.audioVisible = true;
    },
    closeAudioHandler() {
      const audio = document.getElementById("my-dialog-audio");
      if (audio) {
        audio.pause();
      }
    },
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      if (this.activityName) {
        document.title = `${this.activityName} - 报名列表 - ${suffix}`;
      } else {
        document.title = `报名列表 - ${suffix}`;
      }
      console.log(document.title, "document.title");
    },
    // 文件大小格式化函数
    formatFileSize(size) {
      if (!size) return "0B";
      if (size < 1024) {
        return size + "B";
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(1) + "KB";
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(1) + "MB";
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(1) + "GB";
      }
    },
    getFullImageUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//.test(path)) {
        return path;
      }
      return this.imageUrl2 + path;
    },
    headerCellStyle() {
      return {
        background: "#f7f8fa",
        color: "#333",
        fontSize: "15px",
      };
    },
    monthValueChange(e) {
      console.log(e);
      console.log(this.detailPeople.signInfoArray, "报名信息改了吗--时间");
    },
    checkboxChange(event, idx) {
      this.detailPeople.signInfoArray[idx].value = event;
    },
    downLoadCodePic(url) {
      this.downloadIamge(url, new Date().valueOf());
    },

    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名

      var image = new Image();

      // 解决跨域 Canvas 污染问题

      image.setAttribute("crossOrigin", "Anonymous");

      image.onload = function () {
        var canvas = document.createElement("canvas");

        canvas.width = image.width;

        canvas.height = image.height;

        var context = canvas.getContext("2d");

        context.fillStyle = "#FFFFFF";

        context.fillRect(0, 0, canvas.width, canvas.height);

        context.drawImage(image, 0, 0, image.width, image.height);

        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素

        var event = new MouseEvent("click"); // 创建一个单击事件

        a.download = name || "photo"; // 设置图片名称

        a.href = url; // 将生成的URL设置为a.href属性

        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    handleChange() {
      var loc = "";
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += codeToText[this.selectedOptions[i]];
      }
      console.log(loc);

      if (loc.length > 0) {
        this.detailPeople.signInfoArray[this.SSQIndex].value = loc;
      }
    },
    // 上传音频
    handleMpThreeUpload(event, idx) {
      var that = this;
      this.selectedFile = event.target.files;
      console.log(this.selectedFile, "文件信息啊--音频");
      for (let i = 0; i < this.selectedFile.length; i++) {
        let name = this.selectedFile[i].name;
        let size = this.selectedFile[i].size;
        // 判断后缀名
        let lastArr = this.selectedFile[i].name.split(".");
        if (lastArr[1] != "mp3") {
          this.$message("文件格式不正确");
          return;
        } else {
          // 加载中
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (this.selectedFile[i].size / 1048576 > 10) {
            this.$message("文件大小应该小于10M");
            loading.close();
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularMP3",
            };

            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                console.log("文件上传成功", response);
                loading.close();
                if (response.data.status == 1) {
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  console.log(_json, "json三生三世");

                  // 先将value初始化为对象
                  that.detailPeople.signInfoArray[idx].value = {
                    name: _json.name,
                    size: _json.size,
                    url: this.imageUrl + _json.fileUrl,
                  };

                  // 强制更新audio元素
                  this.$nextTick(() => {
                    const audio = document.getElementById("myAudio");
                    if (audio) {
                      audio.load();
                    }
                  });
                } else {
                  this.$message(response.data.msg);
                }
              })
              .catch((error) => {
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },
    // 上传视频
    handleMpFourUpload(event, idx) {
      var that = this;
      this.selectedFile = event.target.files[0];
      // console.log(this.selectedFile, "文件信息啊7878787");
      let lastArr = this.selectedFile.name.split(".");
      // console.log(lastArr, "格式不对？？？");
      if (lastArr[1] != "mp4") {
        this.$message("文件格式不正确");
        return;
      }
      if (this.selectedFile.size / 1048576 > 10) {
        this.$message("文件大小小于10M");
        return;
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      // console.log(event,idx, "this.event----idx");

      var userData = '{"Vod":{}}';
      // console.log(event.target.files[0], "event.target.files[0]");
      // console.log( , "uploader-------");
      uploader = this.initUploader(async function (uploadInfo, loading) {
        // 定义延迟函数
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        let videoUrl = "";
        let retryCount = 0;
        const maxRetries = 3;

        // 重试获取视频URL
        while (retryCount < maxRetries) {
          try {
            videoUrl = await that._getNewVideoPathUrl(
              uploadInfo.videoId,
              uploadInfo.value
            );

            if (videoUrl && videoUrl !== "") {
              // 成功获取到视频URL
              console.log(`成功获取视频URL: ${videoUrl}`);
              that.detailPeople.signInfoArray[idx].value = videoUrl;
              that.detailPeople.signInfoArray[idx].vid = uploadInfo.videoId;
              loading.close();
              break;
            } else {
              // URL为空，准备重试
              retryCount++;
              if (retryCount < maxRetries) {
                console.log(
                  `视频URL获取失败，第${retryCount}次重试，共${maxRetries}次...`
                );
                // 使用递增的延迟时间：1秒、2秒、3秒
                await delay(retryCount * 1000);
              }
            }
          } catch (error) {
            console.error(`获取视频URL时发生错误: `, error);
            retryCount++;
            if (retryCount < maxRetries) {
              console.log(
                `发生错误，第${retryCount}次重试，共${maxRetries}次...`
              );
              await delay(retryCount * 1000);
            }
          }
        }

        // 检查最终结果
        if (!videoUrl || videoUrl === "") {
          console.error(`获取视频URL失败，已重试${maxRetries}次`);
          that.$message.error(`视频处理失败，请稍后重试`);
          loading.close();
        }
      });
      uploader.addFile(event.target.files[0], null, null, null, userData);

      // var parm = {
      //   file: this.selectedFile,
      //   type: "modularMP4",
      // };
      // axios
      //   .post(serverConfig.baseURL + "/file/uploadFile", parm, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       "Access-Token": localStorage.getItem("token"),
      //     },
      //   })
      //   .then((response) => {
      //     loading.close();
      //     console.log("上传成功", response);
      //     that.detailPeople.signInfoArray[idx].value = response.data.msg;
      //   })
      //   .catch((error) => {
      //     loading.close();
      //     console.log("图片上传失败", error);
      //   });
    },

    // 上传图片
    handleImgUpload(event, idx) {
      // this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;
      console.log(event, "event");
      var pettern = /^image/;
      for (let i = 0; i < 9; i++) {
        if (!this.selectedFile[i]) {
          return;
        }
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("图片大小小于5M");
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              console.log("图片上传成功", response);
              if (response.data.status == 1) {
                if (this.detailPeople.signInfoArray[idx].value.length >= 9) {
                  this.$message("最多添加9张图片");
                } else {
                  if (this.detailPeople.signInfoArray[idx].value == "") {
                    this.detailPeople.signInfoArray[idx].value = [];
                  }
                  this.detailPeople.signInfoArray[idx].value.push(
                    response.data.msg
                  );
                }
              } else {
                this.$message(response.data.msg);
              }
            })
            .catch((error) => {
              console.log("err:", error);
            });
        }
      }
    },
    singleSelectChange(event, idx) {
      this.detailPeople.signInfoArray[idx].value = event;
    },
    handleFilesUpload(event, idx, info) {
      console.log(this.detailPeople, info, "信息哦哦哦");
      this.selectedFile = event.target.files;

      if (this.selectedFile.length >= 9) {
        this.$message("最多添加9张图片");
        return false;
      }

      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (let i = 0; i < this.selectedFile.length; i++) {
        let name = this.selectedFile[i].name;
        let size = this.selectedFile[i].size;
        // 判断后缀名
        let lastArr = this.selectedFile[i].name.split(".");
        if (
          lastArr[1] != "pdf" &&
          lastArr[1] != "ppt" &&
          lastArr[1] != "doc" &&
          lastArr[1] != "docx" &&
          lastArr[1] != "xls" &&
          lastArr[1] != "xlsx" &&
          lastArr[1] != "zip"
        ) {
          loading.close();
          event.target.value = "";
          this.$message("文件格式不正确");
          return;
        } else {
          if (this.selectedFile[i].size / 1048576 > 10) {
            loading.close();
            event.target.value = "";
            this.$message("请上传大小不超过10MB文件");
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularFile",
            };
            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                loading.close();
                if (response.data.status == 1) {
                  if (this.detailPeople.signInfoArray[idx].value == "") {
                    this.detailPeople.signInfoArray[idx].value = [];
                  }
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  this.detailPeople.signInfoArray[idx].value.push(_json);
                } else {
                  this.$message(response.data.msg);
                }
              })
              .catch((error) => {
                event.target.value = "";
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },

    // 删除文件
    delFile(index) {
      this.detailPeople.signInfoArray[index].value.splice(index, 1);
    },

    subAddress() {
      window.addEventListener(
        "message",
        (event) => {
          // console.log("this.addressIdx", this.addressIdx)
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          const loc = event.data;
          // console.log(loc,'jjjj')
          // _this.addressData = []
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            this.address = loc.poiaddress;
            this.poiname = loc.poiname;
            this.latitude = loc.latlng.lat;
            this.longitude = loc.latlng.lng;
          }
        },
        false
      );
    },
    //地图选点确定
    submitMap() {
      if (
        this.address == null ||
        this.latitude == null ||
        this.longitude == null
      ) {
        this.$message.error("请先选择地址！");
        return;
      }
      console.log(this.address, "this.address");
      this.addressDialog = false;

      this.detailPeople.signInfoArray[this.addressIndex].value.address =
        this.address;
      this.detailPeople.signInfoArray[this.addressIndex].value.name =
        this.poiname;
      this.detailPeople.signInfoArray[this.addressIndex].value.latitude =
        this.latitude;
      this.detailPeople.signInfoArray[this.addressIndex].value.longitude =
        this.longitude;
    },

    //修改地址
    changeAddressClick(index) {
      console.log(index);
      // <div>{{ infoItem.value.name }}</div>
      // <div>{{ infoItem.value.address }}</div>
      this.addressDialog = true;

      this.addressIndex = index;
    },

    changeShengshiqu(index) {
      this.SSQIndex = index;
    },
    // 更换视频
    changeVideoClick(index) {
      // this.detailPeople.signInfoArray[index].value = "";
    },
    //删除一张图片
    delPicClick(index, picIndex) {
      this.detailPeople.signInfoArray[index].value.splice(picIndex, 1);
    },
    //删除视频
    delVideoClick(index) {
      this.detailPeople.signInfoArray[index].value = "";
    },

    //开关是否允许查看
    switchChange(row) {
      console.log(row);
      // 是否允许查看接口 allow_viewing: 2 //是否允许他人查看 默认1 允许 2 不允许
      updateSignInfoLook({
        joinNum: 1,
        projectVos: [],
        activityId: this.activityId,
        allow_viewing: row.canLook == true ? "1" : "2",
        fmSignListId: row.fm_sign_list_id,
        id: row.id,
        isItOneself: this.isOtherPeople == 3 ? 1 : 2,
        signInfo: row.old_sign_info,
        updateName: row.sign_info[0].value,
        addTime: row.add_time.split(" ")[0],
      }).then((res) => {
        if (res.status == 1) {
          this.$message({
            message: "修改成功",
            type: "success",
          });

          this.getMessage();
        } else {
          this.$message({
            message: res.msg,
            type: "false",
          });
        }
      });
    },
    getProjectManageAdmin() {
      getProjectManageAdmin({ activityId: this.activityId }).then((res) => {
        this.isOtherPeople = res.data;
      });
    },

    handleSizeChange(pageSize) {
      this.tablePage.pageNum = 1;
      this.tablePage.pageSize = pageSize;
      this.getMessage();
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    handlePageChange(currentPage) {
      this.tablePage.pageNum = currentPage;
      this.getMessage();
    },

    sortTypeChange() {
      this.getMessage();
    },
    getMessage(extendParams = {}) {
      // this.$refs.audio.pause();
      this.stopAudio();
      this.stopVideo();
      this.tableLoading = true;
      getSignList({
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.pageNum,
        signShowType: 1,
        activityKey: this.activityKey,
        sortType: this.sortType,
        ...extendParams,
      })
        .then((res) => {
          if (res.status == 1) {
            this.tablePage.total = res.data.pageInfo.total;
            this.activityId = res.data.pageInfo.list[0].activity_id;
            if (res.data.pageInfo.list.length > 0) {
              var titleArr = res.data.pageInfo.list[0].sign_info;
              for (const key in titleArr) {
                let strArr = titleArr[key].key.split("_");

                titleArr[key].title = strArr[0];
                titleArr[key].id = strArr[1];
              }
              this.titleArray = titleArr;

              // 批量去重每个list的tags
              if (res.data.pageInfo && Array.isArray(res.data.pageInfo.list)) {
                res.data.pageInfo.list.forEach((item) => {
                  if (Array.isArray(item.tags)) {
                    item.tags = this.dedupeTagsByGroup(item.tags);
                  }
                });
              }

              for (const key in res.data.pageInfo.list) {
                let item = res.data.pageInfo.list[key];
                if (item.allow_viewing == 2) {
                  item.canLook = false;
                } else {
                  item.canLook = true;
                }

                for (const subkey in item.sign_info) {
                  let subItem = item.sign_info[subkey];
                  if (subItem.type == 5 && subItem.value.length > 0) {
                    subItem.value = subItem.value.split(",");
                  }
                }

                // console.log(item, "列表数据");
              }
              // 判断是否允许查看
            }
            this.tableData = res.data.pageInfo.list.map((i) => {
              let tags = {};
              if (i.tags.length > 0) {
                i.tags.forEach((tag) => {
                  tags[tag.tag_group] = tag;
                });
              }
              return {
                ...i,
                tags,
              };
            });
            this.tableLoading = false;
            // console.log(this.tableData);

            // 强制更新audio元素
            this.$nextTick(() => {
              const audio = document.getElementById("tableAudio");
              if (audio) {
                audio.load();
              }
            });
            this.getProjectManageAdmin();
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    // 自动加载所有视频字段的视频地址
    async autoLoadVideos() {
      // 收集所有需要加载的视频字段
      const videoFields = [];
      this.tableData.forEach((item) => {
        console.log("item.sign_info----->>>>", item);

        if (item.sign_info && Array.isArray(item.sign_info)) {
          item.sign_info.forEach((fieldItem) => {
            // 检查是否为视频字段且没有视频地址
            if (
              fieldItem.type == 6 &&
              fieldItem.vid &&
              fieldItem.value &&
              (!fieldItem.videoUrl || fieldItem.videoUrl === "") &&
              !fieldItem.videoLoading
            ) {
              videoFields.push(fieldItem);
            }
          });
        }
      });

      if (videoFields.length > 0) {
        const batchSize = 3; // 每批最多3个
        for (let i = 0; i < videoFields.length; i += batchSize) {
          const batch = videoFields.slice(i, i + batchSize);
          await Promise.allSettled(
            batch.map((fieldItem) => this._getVideoUrlForField(fieldItem))
          );
          if (i + batchSize < videoFields.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
      }
    },
    // 为字段项获取视频地址
    async _getVideoUrlForField(fieldItem) {
      console.log(fieldItem, "fieldItem");

      if (!fieldItem.vid || !fieldItem.value) {
        this.$set(fieldItem, "videoLoading", false);
        return "";
      }

      try {
        const videoUrl = await this._getNewVideoPathUrl(
          fieldItem.vid,
          fieldItem.value
        );
        // 更新字段项的 videoUrl 属性
        this.$set(fieldItem, "videoUrl", videoUrl);
        this.$set(fieldItem, "videoLoading", false);
        return videoUrl;
      } catch (error) {
        console.error("获取视频地址失败:", error);
        this.$set(fieldItem, "videoLoading", false);
        throw error; // 重新抛出错误，让调用方处理
      }
    },
    async _getNewVideoPathUrl(vid, value) {
      // 检查缓存
      const cacheKey = `${vid}_${value}`;
      if (this.videoUrlCache.has(cacheKey)) {
        return this.videoUrlCache.get(cacheKey);
      }

      try {
        const result = await getNewVideoPathUrl({
          vid: vid,
          address: value,
        });
        if (result.status === 1 && result.msg) {
          // 缓存结果
          this.videoUrlCache.set(cacheKey, result.msg);
          return result.msg;
        } else {
          console.error("获取视频地址失败:", result);
          return "";
        }
      } catch (error) {
        console.error("获取视频地址异常:", error);
        return "";
      }
    },
    dedupeTagsByGroup(tags) {
      const uniqueTags = [];
      const groupMap = {};
      for (let i = tags.length - 1; i >= 0; i--) {
        const tag = tags[i];
        const group = tag.tagGroup || tag.tag_group;
        if (tag && group && !groupMap[group]) {
          groupMap[group] = true;
          uniqueTags.unshift(tag);
        }
      }
      return uniqueTags;
    },

    //关闭弹窗
    handleClose() {
      this.drawer = false;

      // this.$refs.audio.pause();
      this.stopAudio();
      this.stopVideo();
    },

    stopAudio() {
      var audio = document.getElementById("myAudio");
      if (audio) {
        audio.pause();
      }
    },

    stopVideo() {
      const video = document.getElementById("video");
      if (video) {
        video.pause();
      }
    },

    //查看
    lookClick(row) {
      this.editItem = row;
      this.canEdit = false;
      this.canTalk = false;
      this.add_time = row.add_time;
      this.getDetail(row.id);
    },
    //编辑
    editClick(row) {
      this.commonInfo = row;
      // this.fetchActivityCode()
      console.log(row, "每一条详情");
      this.canEdit = true;
      this.canTalk = false;
      this.editItem = row;
      this.add_time = row.add_time;
      this.getDetail(row.id);
      this.selectedOptions = [];
      this.SSQIndex = null;
    },

    fetchActivityCode() {
      let scene =
        "id=" +
        this.commonInfo.id +
        "&st=see&ity=" +
        this.commonInfo.activity_type;
      console.log(scene, "scene");
      getActivityCode({
        activityId: this.$route.query.activityId,
        page: "pages-mine/solataireGroupDetails/solataireGroupDetails",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.codeUrl = this.imageUrl + res.data.smallCode;
          this.$nextTick(() => {
            this.manageDialogVisible = true;
          });
        }
      });
    },

    talkClick(row) {
      this.canEdit = false;
      this.canTalk = true;
      this.editItem = row;
      this.getDetail(row.id);
    },
    //删除
    delClick(row) {
      var that = this;
      this.$confirm("确定删除该用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          signDel({
            activityId: this.activityId,
            id: row.id,
            userId: this.userID,
          }).then((res) => {
            if (res.status == 1) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              that.getMessage();
            } else {
              this.$message({
                message: res.msg,
                type: "false",
              });
            }
          });
        })
        .catch(() => {});
    },

    // 获取详情
    getDetail(id) {
      sleDetails({
        activityId: this.activityId,
        id: id,
      }).then(async (res) => {
        console.log(res, "详情数据");
        if (res.status == 1) {
          var detailMessage = res.data[0];
          let signInfoArray = JSON.parse(detailMessage.signInfo);
          // console.log("signInfoArray", signInfoArray);
          for (const key in signInfoArray) {
            let item = signInfoArray[key];
            if (item.type == 4) {
              // 多选
              let contentArray = JSON.parse(item.content);
              item.contentArray = contentArray;
              if (
                item.value == undefined ||
                item.value == true ||
                item.value == false
              ) {
                item.value = [];
              }
            }
            if (item.type == 6 && item.vid && item.value) {
              item.value = await this.getVideoUrl(item);
            }
            // if (item.type == 2){
            //     item.name = item.value;
            // }
          }
          detailMessage.signInfoArray = signInfoArray;
          this.detailPeople = detailMessage;
          this.drawer = true;

          // 强制更新audio元素
          this.$nextTick(() => {
            const audio = document.getElementById("myAudio");
            if (audio) {
              audio.load();
            }
          });

          console.log(this.detailPeople.signInfoArray, "signInfoArray===");
        } else {
          this.$message({
            message: res.msg,
            type: "false",
          });
        }
      });
    },

    // 修改提交
    onSubmit() {
      if (this.canTalk == true) {
        // 评论接口
        this.updatecommentlanguage();
      } else {
        // 编辑接口

        this.editSupport();
      }
    },

    // 评论
    updatecommentlanguage() {
      updatecommentlanguage({
        activityId: this.activityId,

        id: this.detailPeople.id,
        addcomment: this.detailPeople.addcomment,
      }).then((res) => {
        if (res.status == 1) {
          this.$message({
            message: "修改成功",
            type: "success",
          });

          this.drawer = false;
          this.getMessage();
        } else {
          this.$message({
            message: res.msg,
            type: "false",
          });
        }
      });
    },
    editSupport() {
      for (const key in this.detailPeople.signInfoArray) {
        let item = this.detailPeople.signInfoArray[key];

        if (item.value == "" && item.isRequired == 1) {
          this.$message.error(item.fieldName + "不能为空");
          return false;
        }
        if (item.type == 10 && item.isRequired != 1 && item.value != "") {
          const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (!idCardReg.test(item.value)) {
            this.$message.error("请输入正确的身份证号码");
            return false;
          }
        }
        // 时间区间
        if (item.type == 31 && item.value && Array.isArray(item.value)) {
          item.value = item.value.join("~");
        }
      }

      // 如果验证都通过了，才继续执行
      let signInfo = JSON.stringify(this.detailPeople.signInfoArray);
      console.log(signInfo, "报名信息啊");
      // 修改报名信息接口
      updateSignInfo({
        activityId: this.activityId,
        signInfo: signInfo,
        fmSignListId: this.detailPeople.fmSignListId,
        joinNum: 1,
        name: this.detailPeople.name,
        id: this.detailPeople.id,
        projectVos: [],
        isItOneself: this.isOtherPeople == 3 ? 1 : 2,
        updateName: this.detailPeople.signInfoArray[0].value,
        addTime: this.detailPeople.signInfoArray[0].addTime.split(" ")[0],
      }).then((res) => {
        if (res.status == 1) {
          this.$message({
            message: "修改成功",
            type: "success",
          });

          this.drawer = false;
          this.getMessage();
        } else {
          this.$message({
            message: res.msg,
            type: "false",
          });
        }
      });
    },
    validateIdCard(infoItem) {},
    onSearch() {
      this.getMessage();
    },
    openTagDialog(groupIdx) {
      this.editingGroupIdx = groupIdx;
      this.editTags = this.availableTags[groupIdx]
        ? this.availableTags[groupIdx].map((tag) => ({
            ...tag,
            // 修改操作
            isAdd: 2,
            tagColor: tag.tagColor || tag.tagColor, // 兼容历史数据（已统一为tagColor）
          }))
        : [];
      this.groupName = this.editTags[0].tagGroup;
      this.tagDialogVisible = true;
    },
    addTagGroup() {
      this.groupName = "";
      console.log(this.availableTags, "标签");
      this.editingGroupIdx = this.availableTags.length; // 新组下标
      // const groupName = `标签${this.availableTags.length + 1}`;
      const groupName = this.groupName;
      this.editTags = [
        {
          id: Date.now() + 1,
          tagName: "",
          tagColor: "#409eff",
          ifDel: 2,
          isAdd: 1,
          activityId: this.activityId,
          tagGroup: groupName,
        },
        {
          id: Date.now() + 2,
          tagName: "",
          tagColor: "#67c23a",
          ifDel: 2,
          isAdd: 1,
          activityId: this.activityId,
          tagGroup: groupName,
        },
        {
          id: Date.now() + 3,
          tagName: "",
          tagColor: "#f56c6c",
          ifDel: 2,
          isAdd: 1,
          activityId: this.activityId,
          tagGroup: groupName,
        },
        {
          id: Date.now() + 4,
          tagName: "",
          tagColor: "#e6a23c",
          ifDel: 2,
          isAdd: 1,
          activityId: this.activityId,
          tagGroup: groupName,
        },
      ];
      this.tagDialogVisible = true;
    },
    async confirmTagEdit() {
      // 校验：禁止有空标签名称
      const emptyTag = this.editTags.find(
        (tag) => tag.ifdel === 2 && (!tag.tagName || !tag.tagName.trim())
      );
      if (emptyTag) {
        this.$message.error("标签名称不能为空！");
        return;
      }
      // 统一本组tagGroup
      // const groupName = `标签${
      //     (this.editingGroupIdx ?? this.availableTags.length) + 1
      // }`;
      const groupName = this.groupName;
      let group;
      group = this.editTags
        .filter((tag) => tag.tagName && tag.tagName.trim() !== "")
        .map((tag) => ({
          id: tag.id,
          tagName: tag.tagName,
          tagColor: tag.tagColor,
          ifDel: tag.ifDel,
          activityId: this.activityId,
          tagGroup: groupName,
        }));
      let groupclone;
      if (this.editingGroupIdx === this.availableTags.length) {
        // 新建分组，不传id
        groupclone = this.editTags
          .filter((tag) => tag.tagName && tag.tagName.trim() !== "")
          .map((tag) => ({
            tagName: tag.tagName,
            tagColor: tag.tagColor,
            ifDel: tag.ifDel,
            isAdd: tag.isAdd,
            activityId: this.activityId,
            tagGroup: groupName,
          }));
      } else {
        // 编辑分组，传id
        groupclone = this.editTags
          .filter((tag) => tag.tagName && tag.tagName.trim() !== "")
          .map((tag) => ({
            id: tag.id,
            tagName: tag.tagName,
            tagColor: tag.tagColor,
            ifDel: tag.ifDel,
            isAdd: tag.isAdd,
            activityId: this.activityId,
            tagGroup: groupName,
          }));
      }
      try {
        console.log(groupclone);

        const res = await updateTag(groupclone); // 调用接口
        if (res.status === 0) {
          return this.$message.error(res.msg);
        }
        // 接口成功后再更新前端 availableTags
        // if (this.editingGroupIdx === this.availableTags.length) {
        //   this.availableTags.push(group);
        //   this.selectedTags.push(group[0] || null);
        // } else {
        //   this.$set(this.availableTags, this.editingGroupIdx, group);
        //   // 若当前选中的标签已被删掉，自动选第一个
        //   if (
        //       !group.find(
        //           (tag) =>
        //               this.selectedTags[this.editingGroupIdx] &&
        //               tag.id === this.selectedTags[this.editingGroupIdx]
        //       )
        //   ) {
        //     this.$set(
        //         this.selectedTags,
        //         this.editingGroupIdx,
        //         group[0] || null
        //     );
        //   }
        // }
        this.tagDialogVisible = false;
        this.fetchTagList();
        this.getMessage();
        this.$message.success("标签保存成功");
      } catch (e) {
        this.$message.error("标签保存失败");
      }
    },
    onTopTagChange(groupIdx, tagId) {
      this.$set(this.selectedTags, groupIdx, tagId);
    },
    async selectGroupTag(row, groupIdx, tag) {
      // console.log("row--------",JSON.stringify(row));

      try {
        const res = await setOrderTag({
          activityId: this.activityId,
          tagName: tag.tagName,
          tagColor: tag.tagColor,
          orderId: row.id,
          tagGroup: tag.tagGroup,
        });
        console.log(res, "resres");
        if (res && res.status == 1) {
          // if (!row.tags) this.$set(row, "tags", []);
          // row.tags.push(tag)
          this.$set(row.tags, tag.tagGroup, tag);
          this.fetchTagList();
          this.$forceUpdate();
          // console.log("row111--------",JSON.stringify(row.tags));

          this.$message.success("标签设置成功");
        } else {
          this.$message.error(res.msg || "标签设置失败");
        }
      } catch (e) {
        this.$message.error("网络异常，标签设置失败");
      }
      // if (!row.tags) this.$set(row, 'tags', []);
      // this.$set(row.tags, groupIdx, tag);
      // this.$forceUpdate();
    },
    async removeTag(idx) {
      if (this.editTags[idx]) {
        this.$set(this.editTags[idx], "ifDel", 1);
      }
    },
    addTag() {
      this.editTags.push({
        tagName: "",
        isAdd: this.editingGroupIdx === this.availableTags.length ? 1 : 2,
        tagColor: "#409eff",
      });
    },
    deleteTagGroup(groupIdx) {
      // 删除标签分组
      this.availableTags.splice(groupIdx, 1);
      // 删除每行对应的标签
      this.tableData.forEach((row) => {
        if (row.tags && Array.isArray(row.tags)) {
          row.tags.splice(groupIdx, 1);
        }
      });
      // 如有 selectedTags、editTags 等同步处理
      if (this.selectedTags) this.selectedTags.splice(groupIdx, 1);
      if (this.editTags) this.editTags.splice(groupIdx, 1);
      if (
        typeof this.editingGroupIdx === "number" &&
        this.editingGroupIdx >= groupIdx
      ) {
        this.editingGroupIdx = null;
      }
    },
    resetGroupTags(groupIdx) {
      console.log(groupIdx, "groupIdx", this.availableTags[groupIdx]);
      let tagGroup = this.availableTags[groupIdx][0].tagGroup;
      var that = this;
      this.$confirm("确定删除这个标签吗？删除后无法恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTagByGroup({
            tagGroup: tagGroup,
            activityId: this.activityId,
          }).then((res) => {
            this.tableData.forEach((row) => {
              if (row.tags && Array.isArray(row.tags)) {
                this.$set(row.tags, groupIdx, null);
              }
            });
            that.fetchTagList();
            that.getMessage();
          });
        })
        .catch(() => {});
    },

    showColorPicker(idx, event) {
      // 计算按钮位置，弹窗显示在按钮右侧
      const rect = event.target.getBoundingClientRect();
      this.colorPickerStyle = {
        position: "fixed",
        left: rect.right + 8 + "px",
        top: rect.top + "px",
        zIndex: 3000,
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        padding: "12px",
        minWidth: "220px",
      };
      this.colorPickerIndex = idx;
      this.selectedColor = this.editTags[idx].tagColor; // 同步当前颜色
      this.customColor = this.editTags[idx].tagColor; // 同步到输入框
      this.colorPickerVisible = true;
      // 点击外部关闭
      setTimeout(() => {
        document.addEventListener(
          "mousedown",
          this.handleClickOutsideColorPicker
        );
      }, 0);
    },
    handleClickOutsideColorPicker(e) {
      const pop = document.querySelector(".color-picker-pop");
      if (pop && !pop.contains(e.target)) {
        this.colorPickerVisible = false;
        this.colorPickerIndex = null;
        document.removeEventListener(
          "mousedown",
          this.handleClickOutsideColorPicker
        );
      }
    },
    selectColor(color) {
      this.selectedColor = color;
    },
    handleTagChange(row, tag) {
      this.$set(row, "tags", [tag]);
      this.$forceUpdate();
      console.log(row.tags, "row.tags");
    },
    confirmColor() {
      if (this.colorPickerIndex !== null) {
        this.editTags[this.colorPickerIndex].tagColor = this.selectedColor;
      }
      this.colorPickerVisible = false;
      this.colorPickerIndex = null;
      document.removeEventListener(
        "mousedown",
        this.handleClickOutsideColorPicker
      );
      this.customColor = "";
    },
    colorChange() {
      console.log("选择颜色");
    },
    toggleAllowView(row) {
      row.canLook = !row.canLook;
      this.switchChange(row);
    },
    async fetchTagList() {
      const that = this;
      const res = await listTags({ activityKey: this.activityKey });
      // console.log(res, "标签列表");
      let resResult = Object.values(res.data || {}).reverse();
      // this.availableTags = Object.values(res.data || {}).reverse();
      // this.availableTags = Object.values(res.data || {}).reverse();

      this.availableTagsFilter = resResult.map((i) => ({
        key: i[0].tagGroup,
        filter: [],
        checkAll: false,
        isIndeterminate: false,
      }));
      this.fetchTagListFilterHandler().then((tagFilterRes) => {
        const countList = tagFilterRes.data;
        this.totalCount = countList[0].total_signup_count;
        for (let i = 0; i < resResult.length; i++) {
          const filterItem = resResult[i];
          for (let k = 0; k < filterItem.length; k++) {
            for (let j = 0; j < countList.length; j++) {
              if (
                filterItem[k].tagGroup === countList[j].tag_group &&
                filterItem[k].tagName === countList[j].tag_name
              ) {
                filterItem[k].count = countList[j].count;
              }
            }
          }
        }
        that.availableTags = resResult;
        this.tableKey++;
        // console.log(this.tableKey, "tableKey");
      });
      // this.availableTagsFilter =
    },
    fetchTagListFilterHandler() {
      return listTagsCount({ activityKey: this.activityKey });
    },
    getUniqueTags(group) {
      if (!Array.isArray(group)) return [];
      const uniqueTags = [];
      const tagIdMap = {}; // 改用 id 去重
      for (let i = group.length - 1; i >= 0; i--) {
        const tag = group[i];
        if (
          tag &&
          tag.id !== undefined &&
          tag.ifDel !== 1 &&
          !tagIdMap[tag.id]
        ) {
          tagIdMap[tag.id] = true; // 记录已处理的 id
          uniqueTags.unshift(tag); // 保持原始顺序
        }
      }
      return uniqueTags;
    },
    onCustomColorInput(val) {
      this.selectedColor = val;
    },
  },
  computed: {
    visibleEditTags() {
      return this.editTags.filter((tag) => tag.ifDel !== 1);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .video-popover {
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-box {
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*align-items: center;*/
}

.radio-box .el-radio {
  margin-bottom: 0;
}

.file-box-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-view {
  background-color: #ffffff;
  width: 100%;
  min-height: 500px;
  position: relative;

  &.fullscreen-enable {
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1003;
    background-color: #ffffff;
    overflow: hidden;
    overflow-y: auto;
  }
}

.total-pos {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  color: #000;
  font-weight: bold;
}

.top-view {
  // height: 81px;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
}

.top-view-left {
  display: flex;
  align-items: center;
}

.top-view-right {
  display: flex;
  align-items: center;

  .icon-btn-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    // width: 20px;
    // height: 20px;
    font-size: 16px;
    margin: 0 5px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    padding: 6px;
    transition: color 0.2s, background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }
}

.list-back-view {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
  // width: 1080px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 10px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

.pic-back {
  margin: 5px;
  width: 120px;
  height: 80px;
}

.pic-del-back {
  width: 15px;
  height: 15px;
  position: relative;
  top: -108px;
  right: -99px;
}

.pic-add {
  margin: 5px;
  width: 120px;
  height: 80px;
  background-color: lightgrey;
  text-align: center;
  line-height: 70px;
  font-size: 40px;
  cursor: pointer;
}

.el-icon-delete {
  cursor: pointer;
}

.del-button {
  color: darkgray;
  font-size: 15px;
  text-align: center;
  width: 100%;
}

/* 旧的updateFileBtn样式已废弃，使用新的.file-upload-btn .updateFileBtn样式 */
// .updateFileBtn {
//   width: 120px;
//   height: 80px;
//   position: relative;
//   margin-top: -88px;
//   top: -69px;
//   left: 0;
//   opacity: 0;
//   cursor: pointer;
// }

.updateVideoBtn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.addSmallBtn {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  color: #1877ff;
  border-radius: 4px;
  position: relative;
}

// .el-dropdown-menu {
//   z-index: 3000 !important;
// }
.drawer-nav-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;

  span {
    font-size: 18px;
    color: black;
    font-weight: bold;
  }

  i {
    cursor: pointer;
    font-size: 18px;
  }
}

.detail-form {
  :deep(.el-form-item__label) {
    margin-bottom: 0;
  }
}

.no-wrap {
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.top-view .el-button.search-btn {
  display: flex;
  align-items: center;
  height: 36px;
  border-radius: 6px;
  font-size: 15px;
  line-height: 1;
  padding: 0 18px;
}

.top-view .el-button.search-btn .el-icon-search {
  font-size: 16px;
  margin-right: 4px;
}

.action-btn {
  font-size: 15px;
  margin-right: 12px;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
  display: inline-block;
  line-height: 1;
}

.action-btn.add {
  color: #409eff;
}

.action-btn.copy {
  color: #67c23a;
}

.action-btn.del {
  color: #f56c6c;
}

.action-btn.comment {
  color: #606266;
}

.action-btn:last-child {
  margin-right: 0;
}

.action-btn:hover {
  text-decoration: underline;
}

.tag-cell {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.tag-cell .el-tag {
  margin-right: 2px;
}

.action-btn.tag-btn {
  color: #409eff;
  margin-left: 8px;
}

.tag-edit-list {
  padding: 0 0 10px 0;
}

.tag-edit-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.tag-edit-input {
  flex: 1;
  margin-right: 10px;
}

.tag-edit-color-btn {
  min-width: 80px;
  border: none;
}

.tag-edit-delete {
  color: #f56c6c;
  margin-left: 12px;
  cursor: pointer;
  font-size: 15px;
}

.tag-edit-add {
  color: #409eff;
  background: #f5f7fa;
  border-radius: 4px;
  text-align: center;
  padding: 8px 0;
  margin: 8px 0 0 0;
  cursor: pointer;
  font-size: 15px;
}

.tag-edit-add:hover {
  background: #e6f0fa;
}

.tag-edit-confirm {
  width: 100%;
  background: #409eff;
  color: #fff;
  border-radius: 6px;
  font-size: 16px;
  height: 38px;
  border: none;
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 4px;
  padding: 10px 0 0 0;
  justify-content: flex-start;
}

.color-cell {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #fff;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.2s;
}

.color-cell.active {
  border: 2px solid #409eff;
}

.color-cell .el-icon-check {
  color: #409eff;
  font-size: 18px;
}

.color-more {
  margin: 12px 0 0 0;
  color: #409eff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 15px;
}

.color-more i {
  margin-right: 4px;
}

.color-picker-pop {
  position: fixed;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 220px;
  z-index: 3000;
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.color-cell {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: border 0.2s;
}

.color-cell.active {
  border: 2px solid #1877ff;
}

.color-cell i {
  color: #1877ff;
  font-size: 14px;
}

.color-more {
  margin-top: 6px;
  color: #1877ff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.color-picker-footer {
  margin-top: 10px;
  text-align: right;
}

/* 表格标签样式优化 */
::v-deep .el-tag[style*="background"] {
  color: #fff !important;
  border: none !important;
  box-shadow: none !important;
  height: 28px !important;
  line-height: 28px !important;
}

.custom-arrow {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  display: none;

  /* 可根据需要调整颜色 */
  polygon {
    fill: #8a8b93;
  }
}

::v-deep .cell {
  &:hover {
    .custom-arrow {
      display: block !important;
    }
  }
}

.add_tags {
  width: 103px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  color: #1877ff;
  cursor: pointer;
}

/* 表单项布局优化 - label和组件两行显示 */
.el-form-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  //margin-bottom: 20px !important;
}

.el-form-item__label {
  width: 100% !important;
  text-align: left !important;
  margin-bottom: 0px !important;
  font-weight: 500;
  color: #333;
  font-size: 14px;
  line-height: 1.4;
}

.el-form-item__content {
  width: 100% !important;
  margin-left: 0 !important;
}

/* 确保所有组件都能正确显示 */
.el-form-item .el-input,
.el-form-item .el-select,
.el-form-item .el-date-picker,
.el-form-item .el-time-picker,
.el-form-item .el-cascader,
.el-form-item .el-checkbox-group,
.el-form-item .el-radio-group {
  width: 100%;
}

/* 特殊组件宽度调整 */
.el-form-item .el-time-picker,
.el-form-item .el-date-picker {
  width: 100%;
}

.el-form-item .el-cascader {
  width: 100%;
}

/* 多选和单选组件样式优化 */
.el-form-item .el-checkbox-group,
.el-form-item .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.el-form-item .el-checkbox,
.el-form-item .el-radio {
  margin-right: 0;
  margin-bottom: 8px;
}

/* 省市区组件特殊处理 */
.el-form-item .el-cascader {
  width: 100%;
}

/* 确保现代化组件样式不受影响 */
.el-form-item .modern-image-upload,
.el-form-item .modern-video-upload,
.el-form-item .modern-audio-upload,
.el-form-item .modern-location-upload,
.el-form-item .modern-multi-select {
  width: 100%;
  margin-top: 0;
}

/* 现代化多选下拉组件样式 */
.modern-multi-select {
  width: 100%;
}

.modern-select-dropdown {
  width: 100%;
}

.modern-select-dropdown .el-input__inner {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.modern-select-dropdown .el-input__inner:hover {
  border-color: #409eff;
  box-shadow: 0 4px 8px rgba(64, 158, 255, 0.1);
}

.modern-select-dropdown .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.modern-select-dropdown .el-input__suffix {
  color: #c0c4cc;
  transition: all 0.3s ease;
}

.modern-select-dropdown:hover .el-input__suffix {
  color: #409eff;
}

/* 下拉选项样式 */
.modern-select-dropdown .el-select-dropdown__item {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  transition: all 0.2s ease;
}

.modern-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.modern-select-dropdown .el-select-dropdown__item.selected {
  background-color: #409eff;
  color: #fff;
}

/* 已选标签样式 */
.modern-select-dropdown .el-select__tags {
  margin: 4px 0;
}

.modern-select-dropdown .el-tag {
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  transition: all 0.2s ease;
}

.modern-select-dropdown .el-tag:hover {
  background: #337ecc;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

.modern-select-dropdown .el-tag .el-tag__close {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-left: 4px;
  transition: all 0.2s ease;
}

.modern-select-dropdown .el-tag .el-tag__close:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
}

/* 禁用状态样式 */
.modern-select-dropdown .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.modern-select-dropdown .el-input.is-disabled .el-input__suffix {
  color: #c0c4cc;
}

/* 现代化文件上传组件样式 */
.modern-file-upload {
  width: 100%;
}

.file-list {
  margin-bottom: 16px;
}

.file-item {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.file-item:hover {
  background: #f1f3f4;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.file-icon {
  margin-right: 12px;
  flex-shrink: 0;
}

.file-type-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.excel-icon {
  background: #217346;
}

.pdf-icon {
  background: #dc3545;
}

.word-icon {
  background: #2b579a;
}

.ppt-icon {
  background: #d24726;
}

.zip-icon {
  background: #6c757d;
}

.default-icon {
  background: #6c757d;
}

.file-type-icon i {
  font-size: 18px;
}

.file-info {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 16px;
}

.file-size {
  font-size: 12px;
  color: #6c757d;
  line-height: 16px;
}

.file-delete-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(220, 53, 69, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.file-delete-btn:hover {
  background: rgba(220, 53, 69, 0.2);
  transform: scale(1.1);
}

.file-delete-btn i {
  color: #dc3545;
  font-size: 14px;
}

.file-upload-btn {
  position: relative;
  width: 100%;
  height: 48px;
  background: #409eff;
  border: 2px dashed #409eff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  z-index: 1;
}

.file-upload-btn:hover {
  background: #337ecc;
  border-color: #337ecc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.file-upload-btn span {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin-left: 8px;
}

.upload-icon {
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-icon i {
  color: #fff;
  font-size: 14px;
}

.file-upload-btn .updateFileBtn,
.pic-add .updateFileBtn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 10;
  font-size: 0;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .modern-image-upload {
    gap: 8px;
  }

  .image-item,
  .image-upload-btn {
    width: 100px;
    height: 70px;
  }

  .video-container video {
    height: 150px !important;
  }

  .location-upload-btn,
  .video-upload-btn,
  .audio-upload-btn {
    height: 40px;
    font-size: 13px;
  }

  /* 多选下拉组件移动端优化 */
  .modern-select-dropdown .el-input__inner {
    padding: 10px 12px;
    font-size: 13px;
  }

  .modern-select-dropdown .el-tag {
    font-size: 11px;
    padding: 3px 6px;
    margin: 1px 2px 1px 0;
  }

  .modern-select-dropdown .el-select-dropdown__item {
    padding: 10px 12px;
    font-size: 13px;
  }

  /* 文件上传组件移动端优化 */
  .file-item {
    padding: 10px 12px;
    margin-bottom: 6px;
  }

  .file-type-icon {
    width: 36px;
    height: 36px;
    font-size: 12px;
  }

  .file-name {
    font-size: 13px;
  }

  .file-size {
    font-size: 11px;
  }

  .file-upload-btn {
    height: 44px;
  }

  .file-upload-btn span {
    font-size: 13px;
  }

  .upload-icon {
    width: 20px;
    height: 20px;
  }

  .upload-icon i {
    font-size: 12px;
  }
}

.el-cascader-box {
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 4px 20px 4px 20px;
  color: #1877ff;
  font-size: 14px;
  margin-bottom: 10px;

  p {
    margin-bottom: 0;
  }
}

.location-selector-box {
  display: flex;
  align-items: center;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}

.location-selector-box .location-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.location-selector-box .location-text {
  margin: 0;
  color: #409eff;
}

.address-box {
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 0 12px;
  color: #1877ff;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.address-box:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.address-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
}

.address-content {
  flex: 1;
  min-width: 0;
}

.video-box {
  .pic-del-back {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 0px;
    right: 10px;
  }
}

::v-deep .el-form-item__content {
  width: 100%;

  .read-value {
    border: 1px solid #dddddd;
    border-radius: 6px;
    padding: 0 12px;
    min-height: 40px;
  }
}

.look-time {
  ::v-deep .el-form-item__content {
    width: calc(100% - 200px);
  }
}
</style>
